// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.design-name-input-grid[data-v-062f5cc6] {\n    display: grid;\n    grid-template-columns: auto max-content;\n    grid-column-gap: 10px;\n    margin-bottom: 20px;\n}\n.design-name-input[data-v-062f5cc6] {\n}\n.design-name-button[data-v-062f5cc6]{\n    padding: 5px 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 23px;\n}\n.svg-14[data-v-062f5cc6] {\n    width: 16px;\n    height: 16px;\n}\n\n", ""]);
// Exports
module.exports = exports;
